import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Countdown from 'components/Countdown';
import ZoomMeetingWrapper from 'components/ZoomMeeting';
import { STATUS_SUCCESS } from 'constants/status';
import { MeetingIntro, AvatarWrapper, UserAvatar } from './styles';

class ZoomMeeting extends Component {
  constructor(props) {
    super(props);

    this.state = {
      hasFinishCountdown: false,
    };
  }

  componentDidMount() {
    this.handleNewMeeting();
  }

  componentDidUpdate(prevProps) {
    const { match: { params: { id: prevId } } } = prevProps;
    const { match: { params: { id } } } = this.props;

    if (prevId !== id) {
      this.handleNewMeeting();
    }
  }

  finishCountdown = () => {
    this.setState({ hasFinishCountdown: true });
  }

  handleNewMeeting = () => {
    const {
      match: { params: { id } },
      getMeeting,
    } = this.props;

    getMeeting(id);
  }

  printZoomMeeting = () => {
    const { match: { params: { id } }, meeting: { zoom_data: { join_url: url } } } = this.props;
    return (<ZoomMeetingWrapper meetingId={id} meetingURL={url} />);
  }

  printCountDown = () => {
    const { color, meeting: { image, name, start_date: startTime }, literals } = this.props;

    return (
      <MeetingIntro color={color}>
        <div className='content'>
          <div className='title'>{literals.startingMeetingIn}</div>
          <Countdown time={startTime} onFinish={this.finishCountdown} enabled />
          {(image && image !== '') ? (
            <AvatarWrapper>
              <UserAvatar alt={name} src={image} />
            </AvatarWrapper>
          ) : (
            <AvatarWrapper>
              <UserAvatar className='text-avatar'>
                {name && name !== '' && name.slice(0, 1)}
              </UserAvatar>
            </AvatarWrapper>
          )}
          <div className='name'>{name}</div>
        </div>
      </MeetingIntro>
    );
  }

  render() {
    const { meetingStatus, meeting } = this.props;
    const { hasFinishCountdown } = this.state;

    if (meetingStatus !== STATUS_SUCCESS || !meeting) {
      return null;
    }

    if (meeting.start_date > moment().unix() && !hasFinishCountdown) {
      return this.printCountDown();
    }

    return this.printZoomMeeting();
  }
}

ZoomMeeting.propTypes = {
  match: PropTypes.object.isRequired,
  color: PropTypes.string.isRequired,
  meeting: PropTypes.object,
  meetingStatus: PropTypes.string,
  literals: PropTypes.object.isRequired,
};

ZoomMeeting.defaultProps = {
  meeting: null,
  meetingStatus: null,
};

export default ZoomMeeting;



// WEBPACK FOOTER //
// ./src/routes/ZoomMeeting/components/index.jsx